import Modal from "AC/modules/modal";
var Feedback = /** @class */ (function () {
    function Feedback(form) {
        this.form = form;
        this.initEvents();
    }
    Feedback.prototype.initEvents = function () {
        var self = this;
        var $form = jQuery(this.form);
        $form.submit(function (e) {
            e.preventDefault();
        });
        $form.find('[name=frm_ac_fb_submit]').on('click', function () {
            self._sendData().done(function (response) {
                if (response.success) {
                    $form.find('.ac-modal__dialog__footer').remove();
                    $form.find('.ac-modal__dialog__content').html(response.data);
                }
                else {
                    $form.find('.ac-feedback__error').html(response.data);
                }
            });
        });
    };
    Feedback.prototype._sendData = function () {
        var $form = jQuery(this.form);
        return jQuery.ajax({
            url: ajaxurl,
            method: 'post',
            data: {
                action: 'acp-send-feedback',
                email: $form.find('[name=name]').val(),
                feedback: $form.find('[name=feedback]').val(),
                _ajax_nonce: $form.find('[name=_ajax_nonce]').val()
            }
        });
    };
    return Feedback;
}());
document.addEventListener("DOMContentLoaded", function () {
    AdminColumns.Modals.register(new Modal(document.getElementById('ac-modal-feedback')), 'feedback');
    new Feedback(document.querySelector('#frm-ac-feedback'));
});
